<template>
	<div>
		<div class="top_header">
			<div class="bg">
				<img :src="imgBaseUrl+detail.image" alt="">
			</div>
			<div class="leason_detail flex">
				<div class="leason">
					<!-- <div class="title">课程详情</div> -->
					
					<div class="intro" v-html="detail.details"></div>
				</div>
				<div class="detail">
					<div class="title">Details</div>
					<div class="list">
						<div class="item">{{detail.name}}</div>
						<div class="item">{{detail.age}}</div>
						<!-- <div class="item">{{detail.shop.name}}</div> -->
						<div class="item">{{detail.academic_system}}</div>
						
					</div>
					<!-- <div class="intro_item">Please Note: The Mobile version of our website is still developing, please use your laptop/PC to view our webpages and book classes.</div> -->
					<!-- <div class="buy" @click="toClassPack">{{detail.class_pack_note}}<br><span id="">Click HERE for more info.</span></div> -->
					<img class="intro_img" @click="toClassPack" src="../../../assets/images/icon/click.png" alt="">
					<div class="buy_btn" @click="getShopDetail">Book Now</div>
				</div>
			</div>
		</div>
		<div class="main_picture">
			<div v-html="detail.introduce"></div>
		</div>
		
		<div class="model" v-if="leasonStatus">
			<div class="model_content2">
				<div class="header">
					<div class="title">Classes</div>
					<img src="../../../assets/images/icon/close.png" alt="" @click="leasonStatus = false ">
				</div>
				<div class="list">
					<div class="item flex align-center justify-between" v-for="(item,index) in classifyDetailList" :key="index" @click="toDetail(item.shop.id,item.id)">
						<div class="left">
							<div class="name"><span class="date">{{item.type.name}}</span></div>
							<div class="address">{{item.shop.name}}</div>
						</div>
						<!-- <div class="age">{{item.age.name}}</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Leason from '/src/components/eventLeason/leason.vue'
	export default{
		components:{
			Leason,
		},
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				id:'',
				detail:{},
				type:0,
				secondCourseList:[],
				orderDetail:{},
				childList:[],
				selectAll:false,
				hasPack:0,
				combo_num:0,
				selectModel:false,
				weekList:[],
				pid:'',
				leasonStatus:false,
				classifyDetailList:[],
			}
		},
		created(){
			this.id = this.$route.query.id;
			this.getDetail();
			this.getpack();
		},
		methods:{
			// 获取门店信息
			getShopDetail(){
				this.$api.post('Parents/getCourseByType',{course_type_id	:this.id},res=>{
					if(res.code == 1){
						res.data.forEach((item,index)=>{
							var status = false;
							this.classifyDetailList.forEach((ite,ind)=>{
								if(ite.course_shop_id == item.course_shop_id ){
									status = true;
								}
							})
							if(!status){
								this.classifyDetailList.push(item)
							}
							
						})
						// this.classifyDetailList = res.data;
						this.leasonStatus = true;
					}
				})
			},
			toDetail(id,big_id){
				this.$router.push({path:'/home/parent/selectCourse',query:{course_type_id:this.id,course_shop_id:id,big_course:big_id}})
			},
			
			toClassPack(){
				this.$router.push('/home/classPack')
			},
			// 获取套餐余量
			getpack(){
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.hasPack = res.data.combo_num;
					}
				})
			},
			
			
			// 关闭弹窗
			close(){
				this.type = -1;
			},
			getDetail(){
				this.$api.post('Parents/getCourseTypeDetails',{id:this.id},res=>{
					if(res.code == 1){
						res.data.details = this.richText(res.data.details);
						res.data.introduce = this.richText(res.data.introduce);
						this.detail = res.data;
						
					}
				})
			},
			richText(str) {
			  let reg = /<embed.*?(?:>|\/>)/gi;
			  let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
			  let arr = str.match(reg);
			  if (arr) {
			   for (let i = 0; i < arr.length; i++) {
			    let src = arr[i].match(srcReg);
				
			    str = str.replace(arr[i], '<video src="' + src[1] + '" autoplay="true" controls style="width:100%;height:auto;display:block;margin:0 auto;" />');
			   }
			  }
			  let reg2 = /<video.*?(?:>|\/>)/gi;
			  let srcReg2 = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
			  let arr2 = str.match(reg2);
			  if (arr2) {
			   for (let i = 0; i < arr2.length; i++) {
			    let src = arr2[i].match(srcReg2);
			  				
			    str = str.replace(arr2[i], '<video src="' + src[1] + '" autoplay="true" controls style="width:100%;height:auto;display:block;margin:0 auto;" />');
			   }
			  }
			  return str;
			 },
		}
	}
</script>

<style lang="scss" scoped>
	.top_header{
		width: 100%;
		height: 857px;
		position: relative;
		.bg{
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			// z-index: -1;
			img{
				width: 100%;
				height: 100%;
			}
		}
		.leason_detail{
			width: 1200px;
			height: 800px;
			overflow-y: scroll;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			position: absolute;
			top: 32px;
			left: 50%;
			transform: translateX(-50%);
			.leason{
				height: auto;
				width: 820px;
				overflow-x: hidden;
				overflow-y: scroll;
				padding: 40px 30px 30px 40px;
				border-right: 1px solid #5C707A;
				.title{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #282E30;
					text-align: center;
					margin-bottom: 40px;
				}
				.picture{
					width: 100%;
					height: 230px;
					overflow: hidden;
					margin-bottom: 15px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.intro{
					font-size: 16px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 24px;
					text-indent: 2rem;
				}
			}
			.detail{
				width: 380px;
				height: 100%;
				padding: 40px 0 28px;
				.title{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #282E30;
					text-align: center;
					padding-bottom: 40px;
				}
				.intro_img{
					width: 80%;
					height: auto;
					display: block;
					margin: 0 auto;
					cursor: pointer;
				}
				.list{
					padding: 0 40px;
				}
				.item{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					padding: 20px;
					border-top: 1px solid #5C707A;
				}
				.intro_item{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					padding: 20px;
					color: #BF5F49;
				}
				.buy{
					font-size: 18px;
					font-family: Adobe Heiti Std;
					font-weight: normal;
					color: #C98B2C;
					margin-top: 60px;
					text-align: center;
					cursor: pointer;
					span{
						text-decoration: underline;
					}
				}
				.buy_btn{
					width: 182px;
					height: 58px;
					background: #5C707A;
					border-radius: 29px;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #F7F2EB;
					line-height: 58px;
					text-align: center;
					margin: 20px auto;
					cursor: pointer;
					
				}
			}
		}
	}
	.main_picture{
		width: 1200px;
		margin: 50px auto;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.model{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: rgba(0,0,0,0.2);
		z-index: 99;
		.model_content{
			width: 750px;
			height: 80%;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			padding: 30px;
			overflow-y: scroll;
			.header{
				width: 100%;
				height: 88px;
				border-bottom: 1px solid #5C707A;
				position: relative;
				.title{
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #282E30;
					text-align: center;
					line-height: 88px;
				}
				img{
					width: 29px;
					height: 28px;
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
				}
			}
			.item{
				width: 100%;
				height: 140px;
				background: #F7F2EB;
				box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
				border-radius: 10px;
				padding: 25px 20px 20px 40px;
				margin-bottom: 20px;
				cursor: pointer;
				.first_title{
					text-align: center;
					font-size: 22px;
					line-height: 90px;
				}
			}
			.week_list{
				.second_title{
					margin-top: 20px;
					font-size: 30px;
					font-weight: bold;
					color: #282E30;
				}
				.item{
					margin-top: 20px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					color: #282E30;
					font-size: 28px;
				}
			}
		}
		.model_content2{
			width: 750px;
			height: 600px;
			overflow-y: scroll;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			padding: 0 30px;
			.header{
				width: 100%;
				height: 88px;
				border-bottom: 1px solid #5C707A;
				position: relative;
				.title{
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #282E30;
					text-align: center;
					line-height: 88px;
				}
				img{
					width: 29px;
					height: 28px;
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
				}
			}
			.list{
				padding: 40px 0;
				.item{
					width: 100%;
					background: #F7F2EB;
					box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
					border-radius: 10px;
					padding: 25px 20px 20px 40px;
					margin-bottom: 20px;
					
					.name{
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						line-height: 30px;
						span{
							margin-right: 20px;
						}
					}
					.address{
						margin-top: 15px;
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #282E30;
					}
					.age{
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
					}
				}
			}
		}
	}
</style>